import React, { useMemo } from "react";
import { Modal } from "antd";
import CloseIcon from "@mui/icons-material/Close";

import JobSwmsV3AddEditRescueReadinessQuestionForm from "./JobSwmsV3AddEditRescueReadinessQuestionForm";
import { getRescueReadinessQuestionInitialValuesV3 } from "./rescueReadinessQuestionFormConfigV3";
import styles from "../../../../../SwmsMasters/SwmsMastersStyle.module.css";

export default function JobSwmsV3AddEditRescueReadinessQuestionModal({
  visible,
  mode,
  selectedQuestion,
  emergencyPlanOptions,
  onCancel,
  onSubmit
}) {
  const formInitialValues = useMemo(() => getRescueReadinessQuestionInitialValuesV3({
    mode,
    selectedQuestion,
    emergencyPlanOptions
  }), [mode, selectedQuestion, emergencyPlanOptions]);

  return (
    <Modal
      className="cs-modal-v2"
      centered
      footer={null}
      visible={visible}
      onCancel={onCancel}
      afterClose={() => null}
      bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
      destroyOnClose
      closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
    >
      {visible ? (
        <JobSwmsV3AddEditRescueReadinessQuestionForm
          mode={mode}
          selectedQuestion={selectedQuestion}
          initialValues={formInitialValues}
          emergencyPlanOptions={emergencyPlanOptions}
          onClose={onCancel}
          onSubmitSuccess={onSubmit}
        />
      ) : null}
    </Modal>
  );
}
